import { Button, Text, VStack } from '@chakra-ui/react'
import { captureException } from '@sentry/react'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

import { Card } from 'containers/Card'

import { isNetworkError } from 'lib/queryErrors'

import { isStaleChunkError } from '../staleChunkReload'

export function DefaultErrorComponent({ error }: ErrorComponentProps) {
  const router = useRouter()
  const isStaleChunk = isStaleChunkError(error)

  useEffect(() => {
    if (isStaleChunk || isNetworkError(error)) return
    try {
      captureException(error)
    } catch {
      // Sentry may be blocked by adblocker
    }
  }, [error, isStaleChunk])

  if (isStaleChunk) {
    return (
      <Card>
        <VStack align='start' gap={4}>
          <Text layerStyle='heading'>New version available</Text>
          <Text>
            A new version of beadedcloud has been deployed. Please refresh to
            get the latest updates.
          </Text>
          <Button onClick={() => window.location.reload()}>Refresh</Button>
        </VStack>
      </Card>
    )
  }

  return (
    <Card>
      <VStack align='start' gap={4}>
        <Text layerStyle='heading'>Something went wrong</Text>
        <Text>An unexpected error occurred. Please try again.</Text>
        <Button onClick={() => router.invalidate()}>Try Again</Button>
      </VStack>
    </Card>
  )
}
